import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7384891c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "scroll-wrapper",
  ref: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "scroll-content",
    style: _normalizeStyle($options.scrollStyle),
    ref: "content"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "scroll-item",
      key: '1-' + index
    }, _toDisplayString(item), 1);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "scroll-item",
      key: '2-' + index
    }, _toDisplayString(item), 1);
  }), 128))], 4)], 512);
}